import { useGenericRequestHandler } from '../../handlers'

export function useMoteReactUnreactMutation(moteId: string) {
  return useGenericRequestHandler({
    route: `v1/a/reactUnreactMutex/${moteId}`,
    method: 'POST',
    abortable: false
  })
}
